import styled from "@emotion/styled";
import { Box, Flex } from "@radix-ui/themes";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { theme } from "@themes/themes";

import NotFoundIcon from "@assets/404.webp";
import CompassIcon from "@assets/icons/compass.svg?react";

import { Button, Image, Text } from "@src/ui-kit";

const MessageBox = styled(Flex)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background-color: ${theme.color("gray-2")};
  border: 1px solid ${theme.color("gray-4")};
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  min-width: 400px;
  z-index: 10;
`;

export const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box style={{ minHeight: "100vh", padding: "24px", position: "relative" }}>
      <Flex align="center" direction="column" justify="center" style={{ height: "70vh" }}>
        <Image alt="404" src={NotFoundIcon} style={{ width: "50%" }} />
      </Flex>
      <MessageBox>
        <CompassIcon />
        <Text font="body16" weight="medium">
          {t("notFound.message")}
        </Text>
        <Text font="body16" weight="medium">
          {t("notFound.cta")}
        </Text>
        <Button
          size="3"
          fullwidth
          onClick={() => {
            navigate("/trades");
          }}
        >
          {t("common.trade")}
        </Button>
      </MessageBox>
    </Box>
  );
};
